import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import ColorSelection from '@hpstellar/core/visId/ColorSelection';
import ProductTileCarousel from '@hpstellar/core/visId/ProductTileCarousel';
import ProductTileGallery from '@hpstellar/core/visId/ProductTileGallery';
import { Violator } from '@hpstellar/core/visId';
import { mapBundleProducts, getHeaderProps } from '../../../../get-product-props';
import { useGetProductPrice } from '../../../../../hooks/useProductPrice';
import { setDynamicProductData } from '../../../../../search/util';
import { ColorSelectorContainer } from '../../../../../hooks/useColorSelector';
import ProductMobileImages from './product-mobile-images';
import ProductQuickview from '../product-quick-view';
import ProductLabels from './product-labels';
import './product-images.less';

export default ({ product, isMobile, score, reviewsLink, productLinkProps, analyticsData, options, lazyLoad }) => {
    const { gtmAction } = productLinkProps || {};
    const { gtmId, gtmCategory, gtmValue } = gtmAction || {};
    const gtmProductClickProps = gtmId &&
        gtmCategory &&
        gtmValue && {
            'data-gtm-id': gtmId,
            'data-gtm-category': gtmCategory,
            'data-gtm-value': gtmValue,
        };
    const history = useHistory();
    const { to } = productLinkProps || {};
    const priceObj = useGetProductPrice(product, { useSubscriptionsPromo: true });
    const { headerProps } = getHeaderProps(product, priceObj, { combineBadges: false, noViolator: true });
    const { customElement, offerMessage } = headerProps || {};
    const { customContent, sustainability } = customElement || {};
    const {
        images: srcImages = [],
        defaultProductImage = [],
        bundleComponents,
        isBundle,
    } = priceObj && (!product.images || product.images.length === 0)
        ? setDynamicProductData(product, priceObj)
        : product;
    //add default bundles if not yet available as placeholder
    const bundles = mapBundleProducts(bundleComponents, priceObj, false, true) || (isBundle && [{}]);
    const images = srcImages.length > 0 ? srcImages : defaultProductImage;

    const className = images && images.length === 1 ? 'visid-product-tile-single-image' : null;
    const onImageClick = useCallback(
        e => {
            //if target is image route to product page
            if (to && e.target.tagName === 'IMG') {
                history.push(to);
            }
        },
        [to],
    );

    let hasBundles = (bundles && bundles.length > 0) || isBundle;
    let imageCarousel;
    if (isMobile) {
        imageCarousel = <ProductMobileImages images={images} />;
    } else {
        imageCarousel = hasBundles ? (
            <ProductTileGallery bundles={bundles} imageProps={images?.[0]} lazyLoad={lazyLoad} />
        ) : (
            <ProductTileCarousel
                className={className}
                lazyLoad={lazyLoad}
                images={[
                    ...(Array.isArray(images) ? images.map(img => ({ ...(img || {}), ...gtmProductClickProps })) : []),
                ]}
            />
        );
    }

    //wait till dynamic data is available before rendering image carousel.
    return (
        <div className="visid-product-tile-images-and-labels">
            <div className="visid-poduct-tile-image-wrapper">
                {images?.length > 0 && (
                    <ColorSelectorContainer product={product}>
                        {({ colorSelection }) => {
                            return (
                                <>
                                    <div className="offer-message">
                                        {offerMessage && !isMobile && (
                                            <Violator label={offerMessage} theme="light" backgroundColor="red" />
                                        )}
                                        {!isMobile && sustainability}
                                    </div>
                                    {!isMobile && customContent}
                                    <div
                                        className="image-link"
                                        onClick={onImageClick}
                                        {...((hasBundles && gtmProductClickProps) || {})}
                                    >
                                        {imageCarousel}
                                    </div>
                                    {colorSelection && <ColorSelection className="color-picker" {...colorSelection} />}
                                </>
                            );
                        }}
                    </ColorSelectorContainer>
                )}
                <ProductQuickview images={images} product={product} analyticsData={analyticsData} options={options} />
            </div>
            <ProductLabels
                isMobile={isMobile}
                product={product}
                headerProps={headerProps}
                score={score}
                reviewsLink={reviewsLink}
            />
        </div>
    );
};
